import {createContext, useContext, useState, useMemo} from 'react';

export const FarmContext = createContext<IFarmContext>({
  farm: undefined,
  updateCultivationGuid: () => null,
  updateType: () => null,
  updateTitlePage: () => null,
  uploadQualifyPage: () => null,
  resetForm: () => null,
  updateSimpleForm: () => null,
  updateCultivationArea: () => null,
  setOldImages: () => null,
  setDeleteOldImages: () => null,
});

type TShopProviderProps = {
  children: React.ReactNode;
};

export const ShopProvider = ({children}: TShopProviderProps) => {
  const [farm, setFarm] = useState<IFarmAddInfo | undefined>();

  const updateCultivationGuid = (
    cultivationGuid: string | undefined,
    subProduct: string | undefined,
  ) => {
    if (cultivationGuid)
      setFarm(prev => ({
        ...prev,
        cultivationGuid,
        subProduct,
      }));
  };

  const updateType = (type: string | undefined) => {
    if (type)
      setFarm(prev => ({
        ...prev,
        type,
      }));
  };

  const updateTitlePage = (farmData: IFarmUpdateTitlePage) => {
    if (farmData)
      setFarm(prev => ({
        ...prev,
        title: farmData.title,
        description: farmData.description,
        state: farmData.state,
        city: farmData.city,
        hide_phone_number: farmData.hide_phone_number,
      }));
  };

  const uploadQualifyPage = qualifyData => {
    if (qualifyData)
      setFarm(prev => ({
        ...prev,
        images: qualifyData.images,
        existing: qualifyData.existing,
        existing_unit: qualifyData.existing_unit,
      }));
  };
  const resetForm = () => {
    setFarm(undefined);
  };
  const updateSimpleForm = (simpleData: ISimpleFormData) => {
    if (simpleData)
      setFarm(prev => ({
        ...prev,
        price: simpleData.price,
        negotiated_price: simpleData.negotiated_price,
      }));
  };
  const updateCultivationArea = (cultivationData: ICultivationData) => {
    if (cultivationData)
      setFarm(prev => ({
        ...prev,
        area: cultivationData.area,
        harvest_datetime: cultivationData.harvest_datetime,
      }));
  };
  const setOldImages = (images: Array<IImage>) => {
    setFarm(prev => ({...prev, oldImages: images}));
  };
  const setDeleteOldImages = (image: string) => {
    setFarm(prev => {
      if (prev?.deleted_images) {
        if (prev?.deleted_images.indexOf(image) > -1) {
          return {
            ...prev,
          };
        } else
          return {
            ...prev,
            deleted_images: [...prev.deleted_images, image],
          };
      } else {
        return {
          ...prev,
          deleted_images: [image],
        };
      }
    });
  };
  const value = useMemo(
    () => ({
      farm,
      updateTitlePage,
      updateType,
      updateCultivationGuid,
      uploadQualifyPage,
      resetForm,
      updateSimpleForm,
      updateCultivationArea,
      setDeleteOldImages,
      setOldImages,
    }),
    [farm],
  );
  return <FarmContext.Provider value={value}>{children}</FarmContext.Provider>;
};

export const useFarm = () => {
  return useContext(FarmContext);
};
